import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetRoleResponse = App.Http.Responses.Role.GetRoleResponse;
import GetRolesResponse = App.Http.Responses.Role.GetRolesResponse;
import GetRoleRequest = App.Http.Requests.Role.GetRoleRequest;
import GetRolesRequest = App.Http.Requests.Role.GetRolesRequest;

class RoleApi extends TenantBaseApi {
    /**
     * Get list of Settings
     *
     * - Request: -
     * - Response: GetSettingsResponse
     */
    async index(request: GetRolesRequest): Promise<GetRolesResponse> {
        return await this.get<GetRolesResponse, GetRolesRequest>("/roles", {
            params: request,
        });
    }

    /**
     * Get specific Setting
     *
     * - Request: { key: string }
     * - Response: GetSettingResponse
     */
    async show(key: string, request: GetRoleRequest): Promise<GetRoleResponse> {
        return await this.get<GetRoleResponse, GetRoleRequest>(`/roles/${key}`, {
            params: request,
        });
    }
}

export const roleApi = new RoleApi();
